import cleanedFilename from '~/util/cleanedFilename';

export default {
  FIELD_DROPDOWN: `${cleanedFilename(__filename)}-field-dropdown`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
